(function () {
  'use strict';

  // ── Config ──────────────────────────────────────────────
  var KLAVIYO_PUBLIC_KEY = 'UGDsfP';

  // ── Estado global del modal activo ──────────────────────
  var activeContainer = null;

  // ── Helpers DOM ─────────────────────────────────────────
  function $(id) { return document.getElementById(id); }

  // ── Mostrar/ocultar botón BIS según disponibilidad ────────
  function syncCartButton(container, available) {
    if (available) {
      container.setAttribute('hidden', '');
    } else {
      container.removeAttribute('hidden');
    }
  }

  // ── Punto rojo en variantes con stock < 5 ─────────────
  function updateVariantDots() {
    document.querySelectorAll('.bis-dot').forEach(function (d) { d.remove(); });

    var inventory = window.__bisInventory;
    if (!inventory) return;

    // Valores actualmente seleccionados por índice de opción
    var selectedValues = {};
    document.querySelectorAll('.variant-input-wrap').forEach(function (fieldset) {
      var idx = fieldset.dataset.index; // "option1", "option2"...
      var checked = fieldset.querySelector('input:checked');
      if (idx && checked) selectedValues[idx] = checked.value;
    });

    document.querySelectorAll('.variant-input').forEach(function (wrap) {
      var optionIndex = wrap.dataset.index; // "option1"
      var optionValue = wrap.dataset.value; // "S"
      if (!optionIndex || optionValue === undefined) return;

      // Construir combinación de opciones para este botón
      var testValues = {};
      Object.keys(selectedValues).forEach(function (k) { testValues[k] = selectedValues[k]; });
      testValues[optionIndex] = optionValue;

      // Buscar la variante correspondiente
      var variant = null;
      for (var i = 0; i < inventory.length; i++) {
        var v = inventory[i];
        var match = v.options.every(function (opt, idx) {
          return testValues['option' + (idx + 1)] === opt;
        });
        if (match) { variant = v; break; }
      }

      if (!variant) return;

      // Mostrar punto si stock < 5 (incluyendo agotado)
      var isLowStock = variant.management === 'shopify' &&
                       variant.policy === 'deny' &&
                       variant.inventory > 0 &&
                       variant.inventory < 5;

      if (isLowStock) {
        var dot = document.createElement('span');
        dot.className = 'bis-dot';
        dot.setAttribute('aria-hidden', 'true');
        var label = wrap.querySelector('.variant__button-label');
        if (label) {
          label.appendChild(dot);
        } else {
          wrap.appendChild(dot);
        }
        wrap.classList.add('bis-has-dot');
      } else {
        wrap.classList.remove('bis-has-dot');
      }
    });
  }

  // ── Actualizar texto del botón BIS con el nombre de la variante ──
  function updateBisButtonLabel() {
    // El botón siempre muestra el mismo texto — no hacer nada
  }

  // ── Lógica del modal ─────────────────────────────────────
  function openModal(container) {
    activeContainer = container;
    var modal = $('BackInStockModal');
    if (!modal) return;

    // Actualizar subtítulo con nombre de variante seleccionada
    var productTitle = (container && container.dataset.productTitle) || '';
    // Leer el valor del input checkeado (= nombre de la opción, ej: "43,5")
    var checkedInput = document.querySelector('.variant-input-wrap input:checked');
    var variantName = checkedInput ? checkedInput.value : null;
    var subtitle = modal.querySelector('.bis-modal__subtitle');
    if (subtitle) {
      var tplVariant = modal.dataset.subtitleVariant || 'Te avisaremos cuando [V] de [P] vuelva a estar disponible.';
      var tplProduct = modal.dataset.subtitleProduct || 'Te avisaremos cuando [P] vuelva a estar disponible.';
      // Las plantillas son texto plano; la negrita se añade aquí
      function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
      if (variantName && productTitle) {
        subtitle.innerHTML = esc(tplVariant).replace('[V]', '<strong>' + esc(variantName) + '</strong>').replace('[P]', '<strong>' + esc(productTitle) + '</strong>');
      } else if (productTitle) {
        subtitle.innerHTML = esc(tplProduct).replace('[P]', '<strong>' + esc(productTitle) + '</strong>');
      }
    }

    var form       = $('BackInStockForm');
    var success    = $('bis-success');
    var emailInput = $('bis-email');
    var btnLabel   = $('bis-btn-label');
    var btnLoader  = $('bis-btn-loading');
    var submitBtn  = $('bis-submit-btn');

    if (form)       form.style.display = '';
    if (success)    success.setAttribute('hidden', '');
    if (emailInput) { emailInput.value = ''; emailInput.classList.remove('is-invalid'); }
    if (submitBtn)  submitBtn.disabled = false;
    if (btnLabel)   btnLabel.hidden = false;
    if (btnLoader)  btnLoader.hidden = true;

    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    // En iOS no hacer focus automático (desplaza el modal)
    var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (!isIOS) {
      setTimeout(function () { if (emailInput) emailInput.focus(); }, 50);
    }
  }

  function closeModal() {
    var modal = $('BackInStockModal');
    if (modal) modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
    activeContainer = null;
  }

  // ── Tooltip en móvil: click en variante con punto rojo ───
  document.addEventListener('click', function (e) {
    var dotWrap = e.target.closest('.variant-input.bis-has-dot');
    if (dotWrap) {
      // Ocultar otros tooltips abiertos
      document.querySelectorAll('.variant-input.bis-tooltip-visible').forEach(function (el) {
        if (el !== dotWrap) el.classList.remove('bis-tooltip-visible');
      });
      dotWrap.classList.toggle('bis-tooltip-visible');
      // Auto-ocultar tras 2.5s
      clearTimeout(dotWrap._bisTooltipTimer);
      if (dotWrap.classList.contains('bis-tooltip-visible')) {
        dotWrap._bisTooltipTimer = setTimeout(function () {
          dotWrap.classList.remove('bis-tooltip-visible');
        }, 2500);
      }
    } else {
      // Click fuera → ocultar todos
      document.querySelectorAll('.variant-input.bis-tooltip-visible').forEach(function (el) {
        el.classList.remove('bis-tooltip-visible');
      });
    }
  });

  // ── Click en "Notificarme" ────────────────────────────────
  document.addEventListener('click', function (e) {
    // Trigger "Avísame"
    var trigger = e.target.closest('#BackInStockTrigger');
    if (trigger) {
      var container = trigger.closest('.back-in-stock') || $('BackInStockBtn');
      openModal(container);
      return;
    }

    // Botón "Notificarme"
    if (e.target.closest('#bis-submit-btn')) {
      var emailInput = $('bis-email');
      var submitBtn  = $('bis-submit-btn');
      var btnLabel   = $('bis-btn-label');
      var btnLoader  = $('bis-btn-loading');
      var success    = $('bis-success');
      var formDiv    = $('BackInStockForm');

      var email = emailInput ? emailInput.value.trim() : '';

      // Prioridad: bis-variant-id (Liquid) → container data attr → select del form → URL
      var variantId = ($('bis-variant-id') && $('bis-variant-id').value) || '';
      if (!variantId && activeContainer) {
        variantId = activeContainer.dataset.variantId || '';
      }
      if (!variantId) {
        var productSelect = document.querySelector('[data-product-select]') || document.querySelector('select[name="id"]');
        if (productSelect) {
          variantId = productSelect.value
            || (productSelect.querySelector('option[selected]') && productSelect.querySelector('option[selected]').value)
            || '';
        }
      }
      if (!variantId) {
        variantId = new URLSearchParams(window.location.search).get('variant') || '';
      }

      if (!email) {
        if (emailInput) emailInput.classList.add('is-invalid');
        if (emailInput) emailInput.focus();
        return;
      }

      if (emailInput) emailInput.classList.remove('is-invalid');
      if (submitBtn)  submitBtn.disabled = true;
      if (btnLabel)   btnLabel.hidden = true;
      if (btnLoader)  btnLoader.hidden = false;

      subscribeKlaviyo(email, variantId)
        .then(function () {
          if (formDiv) formDiv.style.display = 'none';
          if (success) success.removeAttribute('hidden');
          setTimeout(closeModal, 3000);
        })
        .catch(function (err) {
          console.error('[BIS] Error Klaviyo:', err.message);
          if (submitBtn) submitBtn.disabled = false;
          if (btnLabel)  btnLabel.hidden = false;
          if (btnLoader) btnLoader.hidden = true;
          alert('Error Klaviyo: ' + err.message);
        });
      return;
    }

    // Cerrar overlay o X
    if (e.target.closest('#BackInStockOverlay') || e.target.closest('#BackInStockClose')) {
      closeModal();
    }
  });

  // ── Cambio de variante (Impulse: 'variant:change' en document) ──
  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;
    var variantInput = $('bis-variant-id');
    if (variantInput) variantInput.value = variant.id;
    document.querySelectorAll('.back-in-stock').forEach(function (container) {
      container.dataset.variantId = variant.id;
      syncCartButton(container, variant.available);
    });
    setTimeout(updateVariantDots, 50);
    // Banner "Últimas unidades": mostrar solo si disponible y stock < 5
    var banner = $('bis-low-stock-banner');
    if (banner) {
      banner.setAttribute('hidden', '');
      if (variant.available && window.__bisInventory) {
        for (var i = 0; i < window.__bisInventory.length; i++) {
          var inv = window.__bisInventory[i];
          if (String(inv.id) === String(variant.id)) {
            if (inv.inventory > 0 && inv.inventory < 5) {
              banner.removeAttribute('hidden');
            }
            break;
          }
        }
      }
    }
    updateBisButtonLabel(null);
  });

  // ── Init: mover modal a <body> y sincronizar estado ─────
  function init() {
    // CRÍTICO: sacar el modal del product form para evitar forms anidados
    var modal = $('BackInStockModal');
    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    // Inicializar bis-variant-id con el option[selected] del select de Shopify
    var variantInput = $('bis-variant-id');
    if (variantInput && !variantInput.value) {
      var productSelect = document.querySelector('[data-product-select]') || document.querySelector('select[name="id"]');
      if (productSelect) {
        var selectedOption = productSelect.querySelector('option[selected]');
        if (selectedOption) variantInput.value = selectedOption.value;
      }
    }

    document.querySelectorAll('.back-in-stock:not([hidden])').forEach(function (container) {
      syncCartButton(container, false);
    });

    // Poner puntos rojos en variantes sin stock (con retardo para que Impulse haya aplicado sus clases)
    setTimeout(updateVariantDots, 800);

    // Mostrar banner si la variante por defecto tiene stock bajo
    setTimeout(function() {
      var banner = $('bis-low-stock-banner');
      if (!banner || !window.__bisInventory) return;
      banner.setAttribute('hidden', '');
      var vid = ($('bis-variant-id') && $('bis-variant-id').value) || '';
      if (!vid) {
        var ps = document.querySelector('[data-product-select]') || document.querySelector('select[name="id"]');
        if (ps) vid = ps.value || '';
      }
      if (!vid) return;
      for (var i = 0; i < window.__bisInventory.length; i++) {
        var inv = window.__bisInventory[i];
        if (String(inv.id) === String(vid)) {
          if (inv.available !== false && inv.inventory > 0 && inv.inventory < 5) {
            banner.removeAttribute('hidden');
          }
          break;
        }
      }
    }, 900);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ── Klaviyo Back-in-Stock API ────────────────────────────
  function subscribeKlaviyo(email, variantId) {
    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };

    return fetch(
      'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-06-15'
        },
        body: JSON.stringify(payload)
      }
    ).then(function (res) {
      if (res.status === 202) return;
      if (!res.ok) {
        return res.text().then(function (t) { throw new Error(t); });
      }
    });
  }

})();
